/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Todo_Filter_CountInputs */

const en_todo_filter_count = /** @type {(inputs: Todo_Filter_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`To do (${i?.count})`)
};

/**
* | output |
* | --- |
* | "To do ({count})" |
*
* @param {Todo_Filter_CountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const todo_filter_count = /** @type {((inputs: Todo_Filter_CountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Todo_Filter_CountInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_todo_filter_count(inputs)
});